<!-- <iframe  src="http://192.168.10.201:90/"  name="scanner-iframe" >
    <p>Your browser does not support iframes.</p>
 </iframe> -->

<form [formGroup]="patientForm" novalidate>
    <div class="p-3 border" *ngIf="obj.parent.customCode >'0'">
        <div class="card-block">
            <div class="row">
                <div class="col-3" [hidden]="maritalStatus">
                    <ng-template #popContent>
                        <ul class="list-group">
                            <li class="list-group-item" (click)="selectFamilyMemberType('5') ; popover.close();">
                                {{ 'REGSON' | translate }} </li>
                            <li class="list-group-item" (click)="selectFamilyMemberType('6'); popover.close();">
                                {{ 'REGDAUGHTER' | translate }} </li>
                            <li *ngIf="editPatient.gender == 1" class="list-group-item"
                                (click)="selectFamilyMemberType('8'); popover.close(); ">{{ 'REGWIFE' | translate }}
                            </li>
                            <li *ngIf="editPatient.gender == 2" class="list-group-item"
                                (click)="selectFamilyMemberType('7'); popover.close();">{{ 'REGHUSBND' | translate }}
                            </li>
                            <li class="list-group-item" (click)="selectFamilyMemberType(); popover.close();">
                                {{ 'OTHERS' | translate }} </li>
                        </ul>
                    </ng-template>
                    <button type="button" class="btn btn-success tipped-click" placement="bottom"
                        [ngbPopover]="popContent" #popover="ngbPopover">
                        <span class="fa fa-plus-circle fa-lg"></span>
                        {{ 'ADDFAMILY' | translate }}
                    </button>
                </div>

                <div class="col-9">
                    <span *ngIf="addRelativeMode">{{transtag | translate}}</span>
                    <span>{{ 'FORPATIENT' | translate }}</span> {{obj.parent.customCode }} - {{translate.currentLang ==
                    'ar'? obj.parent.fullnameAr: obj.parent.fullnameEn}}
                </div>
            </div>
        </div>
    </div>
    <div class="p-3 border">

        <div [hidden]="!isParentData">

            <h6 class="card-header">{{'patient' | translate}}</h6>

            <div class="container-fluid py-3">
                <div class="row" [hidden]="!isEmergency">

                    <div class="col-12 col-sm-6 d-flex align-items-end pb-3">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input type="checkbox" #knownCheckBox class="form-check-input" [(ngModel)]="known"
                                    [ngModelOptions]="{standalone: true}" name="known"
                                    (change)="knownFun(knownCheckBox.checked)">
                                {{'UNKNOWNPAT' | translate}}
                            </label>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 d-flex align-items-end pb-3">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input type="checkbox" #hasrecordAccantPatient [checked]="recordAccantPatient"
                                    class="form-check-input" [(ngModel)]="recordAccantPatient"
                                    [ngModelOptions]="{standalone: true}"
                                    (change)="showRecordAccantPatientOptions(hasrecordAccantPatient.checked)">
                                {{'RECORDNUMBEROFPATIENTS' | translate}}
                            </label>
                        </div>
                        <div *ngIf="hasrecordAccantPatient.checked">
                            <label>{{'NUMBERPATIENT' | translate}}</label>
                            <input #len (change)="addItem(len.value)" class="form-control form-control-sm" type="number"
                                formControlName="numberPatient" />
                        </div>
                    </div>




                </div>


                <div class="row">
                    <div class="col-5 col-sm-4 d-flex align-items-end pb-3">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input type="checkbox" #confirmCheckBox class="form-check-input">
                                {{'APATIENTWASBOOKEDBYCALL' | translate}}

                            </label>
                            <span>

                            </span>
                            <sanabel-selectize *ngIf="confirmCheckBox.checked" appcode="1262" [simpleView]='true'
                                (clicked)="setCallerDataToForm($event)">
                            </sanabel-selectize>
                        </div>
                    </div>


                    <!-- مناظرات  الماظه -->
                    <div class="col-8 col-sm-2 d-flex align-items-end pb-3" *ngIf="incubation==1">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input type="checkbox" #confirmDebatesCheckBox class="form-check-input">
                                {{'DEBATES' | translate}}

                            </label>
                            <span>

                            </span>
                            <sanabel-selectize *ngIf="confirmDebatesCheckBox.checked" appcode="1469" [simpleView]='true'
                                (clicked)="setCallerDataToForm($event)">
                            </sanabel-selectize>
                        </div>
                    </div>
                    <div>

                        <label class="form-check-label">
                            <input type="number" class="form-control" [(ngModel)]="patCode"
                                (keyup.enter)="getPatientToEditByCode()" [ngModelOptions]="{standalone: true}"
                                placeholder="تعديل مريض">
                        </label>


                    </div>

                </div>






            </div>
            <div *ngIf="hasrecordAccantPatient.checked">
                <!-- <div class="col p-1 ui-datatable-tablewrapper">
                    <table class="table table-bordered table-striped">
                        <thead class="ui-datatable-thead">
                            <tr>
                                <th>{{ 'patient' | translate  }}</th>
                                <th>{{'EMERGENCY' | translate}}</th>
                                <th>{{ 'serialNumber' | translate  }} </th>
                                <th>{{ 'EMPAGE' | translate  }} </th>
                                <th>{{ 'Gender' | translate  }} </th>
                            </tr>
                        </thead>
                        <tbody class="ui-datatable-data ui-widget-content">
                            <tr class="ui-widget-content" *ngFor="let item of newEmergencyPatient">
                                <td>
                                    <input type="text"  [ngModelOptions]="{standalone: true}"  class="form-control" [(ngModel)]="item.fnameAr">
                                </td>
                                <td>
                                    <input type="text"  [ngModelOptions]="{standalone: true}"  class="form-control" [(ngModel)]="item.snameAr">
                                </td>
                                <td>
                                    <input type="number"  [ngModelOptions]="{standalone: true}"  class="form-control" [(ngModel)]="item.serialNumber">
                                </td>
                                <td>
                                    <input type="number"  [ngModelOptions]="{standalone: true}"  class="form-control" [(ngModel)]="item.age">
                                </td>
                                <td>
                                    <sanabel-selectize [appcode]="1" [excludedCodes]="'3'" [(ngModel)]="item.gender"
                                        [simpleView]="true">
                                    </sanabel-selectize>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
                <p-dataTable tableStyleClass="table table-bordered table-striped" [selectionMode]="'single'"
                    [value]="newEmergencyPatient" [selectionMode]="'single'" [rows]="5" [paginator]="true"
                    [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]">

                    <p-column field="{{translate.currentLang == 'ar'? 'fnameAr':'fnameEn'}}"
                        header="{{ 'patient' | translate }}" [sortable]="true"></p-column>

                    <p-column field="{{translate.currentLang == 'ar'? 'snameAr': 'tnameEn'}}"
                        header="{{ 'EMERGENCY'| translate }}" [sortable]="true"></p-column>

                    <p-column field="serialNumber" header="{{ 'SERIAL'| translate }}" [sortable]="true"></p-column>

                    <p-column field="age" header="{{ 'EMPAGE' | translate }}">
                        <ng-template pTemplate="options" let-row="rowData">
                            <input type="number" class="col-sm-12 form-control form-control-sm"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="row.age">
                        </ng-template>
                    </p-column>

                    <p-column field="gender" header="{{ 'Gender' | translate }}">
                        <ng-template pTemplate="options" let-row="rowData">
                            <sanabel-selectize appcode="1" [simpleView]="true" [excludedCodes]="'3'"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="row.gender">
                            </sanabel-selectize>
                        </ng-template>
                    </p-column>

                    <!-- <p-column field="docCode" header="{{ 'DOCTOR' | translate }}">
                        <ng-template pTemplate="options" let-row="rowData">
                            <sanabel-selectize appcode="1014" [simpleView]="true"
                                [ngModelOptions]="{standalone: true}"  [(ngModel)]="row.docCode">
                            </sanabel-selectize>
                        </ng-template>
                    </p-column> -->


                </p-dataTable>
            </div>

            <div *ngIf="!hasrecordAccantPatient.checked">
                <div class="row">
                    <div class="col-10 mb-3">
                        <name-component #name [nameAllowNumber]="nameAllowNum"
                            [namingTranslationSetting]="namingTranslationSettings"
                            (emitTitleCode)="recevTitleCode($event)">
                        </name-component>
                    </div>

                    <div class="col-2 text-center">
                        <!-- <div class="testClass">
                        <image-upload (OutBase64)="onOutBase64($event)" (OutSavePlaceType)="OutSavePlaceType($event)" [height]="112"
                            [savePlaceType]="savePlaceType" [imageBase64]="docManagementData.base64" [imgMode]="1"></image-upload> 
                    </div> -->
                        <div class="testClass" *ngIf="patientForm.get('code').value">
                            <image-upload-new (OutBase64)="onOutBase64($event)" [documentLookupCode]="17"
                                [SavedId]="patientForm.get('code').value" [height]="112"
                                [imageBase64]="docManagementData.base64" [docFolderLookupSerial]="1" [imgMode]="1">
                            </image-upload-new>
                        </div>
                    </div>
                </div>
                <!-- --تسجيل مريض -->
                <h6 class="card-header">{{'IDENTITY' | translate}}</h6>

                <div class="container-fluid py-3">
                    <div class="row">
                        <div class="col-md-3" [hidden]="this.hiddenFormControls['fatherName']==1">
                            <label for="fatherName">{{'FATHERNAMECUSTOM' | translate}}</label>
                            <input class="form-control form-control-sm" type="text" id="fatherName"
                                formControlName="fatherName" />
                        </div>
                        <div class="col-md-3">
                            <label for="code">
                                {{'PATCODE' | translate}}
                            </label>
                            <input class="form-control form-control-sm" type="number" readonly id="code"
                                formControlName="code" tabindex="12" />
                        </div>
                        <div class="col-md-3" [hidden]="this.hiddenFormControls['customCode']==1">
                            <label for="customCode">
                                {{'PROGRAMCODE' | translate}}
                            </label>
                            <input [disabled]="this.hiddenFormControls['customCode']==1"
                                class="form-control form-control-sm" id="customCode" formControlName="customCode"
                                tabindex="12" />
                        </div>


                        <div class="col-md-3" [hidden]="this.hiddenFormControls['howToReachUs']==1">
                            <label class="small">{{'HOWTOREACHUS' | translate}}</label>

                            <sanabel-selectize appcode="315" [tabindex]="15" formControlName="howToReachUs"
                                [simpleView]="true">
                            </sanabel-selectize>

                        </div>
                    </div>


                    <div class="row">

                        <div class="col-12 col-sm-12 col-md-6 p-0" [hidden]="known">
                            <identity-component [disableIdentity]="false" #identity
                                (identityValueInfoEmitted)="identityValueInfoEmitted($event)">
                            </identity-component>
                        </div>

                        <div class="col-12 col-sm-6 col-md-3 " [hidden]="known">
                            <label for="birthPlace">
                                {{'BirthPlace' | translate}}
                            </label>
                            <input class="form-control form-control-sm" type="text" id="birthPlace"
                                formControlName="birthPlace" tabindex="12" />

                        </div>

                        <!-- <div class="col-12 col-sm-6 col-md-1">
                            <label>
                                {{'APPROXAGE' | translate}}
                            </label>
                            <input type="number" class="form-control" formControlName="approxAge" required autofocus
                                #approxAge (change)="onChange(approxAge.value)">
                        </div> -->
                        <div class="col">
                            <!-- <div class="form-group">
                                <label for="birthDate">
                                    {{'BIRTHDATE' | translate}}
                                </label>
                                <div class="input-group input-group-sm">
                                    <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                                        formControlName="birthDateNgb" tabindex="13" ngbDatepicker
                                        #birthDate="ngbDatepicker" [minDate]="{'year':1900,'month':1,'day':1}"
                                        [maxDate]="today" (navigate)="getHigriDate();calcage($event)"
                                        (change)=" getHigriDate();calcage($event)">
                                    <div class="input-group-addon" (click)="birthDate.toggle()">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                </div>
                            </div> -->
                            <div class="row">
                                <div class="col">
                                    <label for="birthDate">
                                        {{'BIRTHDATE' | translate}}
                                    </label>
                                    <div class="input-group input-group-sm">
                                        <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                                            formControlName="birthDateNgb" tabindex="13" ngbDatepicker
                                            #birthDate="ngbDatepicker" [minDate]="{'year':1900,'month':1,'day':1}"
                                            [maxDate]="today" (navigate)="getHigriDate();calcage($event)"
                                            (change)=" getHigriDate();calcage($event)">
                                        <div class="input-group-addon" (click)="birthDate.toggle()">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4">
                                    <label>
                                        {{'YEAR' | translate}}
                                    </label>
                                    <input type="number" class="form-control" formControlName="ageInYear" required
                                        autofocus #approxAgeYear
                                        (change)="clacBirthDateFromAge(approxAgeYear.value , approxAgeMonth.value ,approxAgeDays.value)">
                                </div>
                                <div class="col-sm-4">
                                    <label>
                                        {{'MONTH' | translate}}
                                    </label>
                                    <input type="number" class="form-control" formControlName="ageInMonth" required
                                        autofocus #approxAgeMonth
                                        (change)="clacBirthDateFromAge(approxAgeYear.value , approxAgeMonth.value ,approxAgeDays.value)">
                                </div>
                                <div class="col-sm-4">
                                    <label>
                                        {{'DAY' | translate}}
                                    </label>
                                    <input type="number" class="form-control" formControlName="ageInDays" required
                                        autofocus #approxAgeDays
                                        (change)="clacBirthDateFromAge(approxAgeYear.value , approxAgeMonth.value ,approxAgeDays.value)">

                                </div>
                            </div>
                            <!-- <div class="form-group birth_day" style="display: none;">
                                <label for="birthDate">
                                    {{'BIRTHDATE' | translate}}
                                </label>
                                <div class="row pl-3 pr-3">
                                    <input class="col px-1 form-control" placeholder="{{'YEAR' | translate}}"
                                        formControlName="ageYear" tabindex="13">
                                    <input class="col px-1 form-control" placeholder="{{'MONTH' | translate}}"
                                        formControlName="ageMonth" tabindex="13">
                                    <input class="col px-1 form-control" placeholder="{{'DAY' | translate}}"
                                        formControlName="ageDay" tabindex="13">
                                </div>
                            </div> -->
                        </div>


                    </div>

                    <div class="row">
                        <div class="form-group col-12 col-sm-6 col-md-6 col-lg-3">

                            <sanabel-selectize appcode="1" [tabindex]="14" #selectizeGender [excludedCodes]="'3'"
                                formControlName="gender">

                            </sanabel-selectize>
                        </div>

                        <div class="form-group col-12 col-sm-6 col-md-6 col-lg-3">
                            <sanabel-selectize appcode="3" [tabindex]="15" #selectizereligion
                                formControlName="religionId">
                            </sanabel-selectize>

                        </div>

                        <div class="form-group col-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <sanabel-selectize appcode="1022" [tabindex]="16" #selectizeMarital
                                    formControlName="maritalStatus">
                                </sanabel-selectize>
                            </div>
                        </div>

                        <div class="form-group col-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label>{{'PATIENTOCCUPATION' | translate}}</label>
                                <sanabel-selectize appcode="126" [SearchKeys]="{NphiesCodes:1}" [tabindex]="17"
                                    #selectizePatientOccupation formControlName="patientOccupation" [simpleView]="true">
                                </sanabel-selectize>
                            </div>
                        </div>
                        <div class="form-group col-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <date-hijri formControlName="dateHijriNgb" (change)="getGregorianFromHigriDate($event)">
                                </date-hijri>
                            </div>
                        </div>

                    </div>

                    <div class="row">
<div class="col-1">
    <div class="form-group">
        <label>{{'countryKey' | translate}}</label>
        <input class="form-control form-control-sm" formControlName="countryKey"  />
    </div>
</div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">

                            <div class="form-group">
                                <label>{{'MOBILENUMBER' | translate}}</label>
                                <input class="form-control form-control-sm" type="text" formControlName="mobile"
                                    tabindex="18" (change)="onMobileKeyUp($event)" required />
                            </div>

                            <div *ngIf="(patientForm.controls['mobile'].errors && (patientForm.controls['mobile'].dirty || patientForm.controls['mobile'].touched))
                            || setMobAlert == true" class="alert alert-danger">

                                <!-- <small [hidden]="(!patientForm.controls['mobile'].errors.pattern) || (!setMobAlert)">
                                    {{'INCORRECT' | translate}}
                                </small> -->
                            </div>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label>{{'HomePhone' | translate}}</label>
                                <input class="form-control form-control-sm" type="number" formControlName="homePhone"
                                    tabindex="19" />
                            </div>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">

                                <label>{{'EMAILADDRESS' | translate}}</label>

                                <input class="form-control form-control-sm" type="email" formControlName="mailAddress"
                                    tabindex="17" />
                                <div class='error' *ngIf="patientForm.controls.mailAddress.touched">
                                    <div *ngIf="patientForm.controls.mailAddress.hasError('invalidEmail')">
                                        {{'INCORRECT' | translate}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-3"
                            [hidden]="this.hiddenFormControls['parentId']==1">
                            <div class="form-group">
                                <label>{{'Parent' | translate}}</label>
                                <sanabel-selectize [customPlaceHolder]="'Parent'" [simpleView]="true" appcode="1023"
                                    [tabindex]="20" formControlName="parentId" (clicked)="getPatMobile($event);">
                                </sanabel-selectize>
                            </div>
                        </div>

                    </div>

                    <div class="form-group">
                        <address-component #address [tabindex]="21"></address-component>
                    </div>

                    <div class="form-group row_margin">
                        <Contract-Id #TherapeuticCards [editable]="contractIsEditable()" [tabindex]="27"
                            [hideDataFromContract]="true" (contractValueInfoEmitted)="contractValueInfoEmitted($event)"
                            [NphiesEligablePatientContractData]="getNphiesEligablePatientContractData()">
                        </Contract-Id>
                    </div>

                </div>

                <h6 class="card-header" [hidden]="isEmergency" (click)="toggleOptionalData()" style="cursor: pointer;">
                    {{'optionamlData' | translate}}</h6>

                <div class="card-block" [hidden]="isEmergency" *ngIf="optianalData">

                    <div class="row">

                        <div class="col-3">
                            <sanabel-selectize appcode="1020" [tabindex]="28" formControlName="employeeId"
                                (clicked)="getPatFromEmp($event);">
                            </sanabel-selectize>
                        </div>

                        <!-- <div class="form-group col-12 col-sm-6 col-md-4">
                            <label class="small">{{'fatherName' | translate}}</label>
                            <input class="form-control form-control-sm" type="text" formControlName="fatherName"
                                tabindex="29" />
                        </div> -->

                        <div class="col-3">
                            <label class="small">{{'motherName' | translate}}</label>
                            <input class="form-control form-control-sm" type="text" formControlName="motherName"
                                tabindex="30" />
                        </div>
                        <div class="col-3">
                            <div class="form-group">
                                <label class="small">{{'filNo' | translate}}</label>
                                <input class="form-control form-control-sm" type="text" formControlName="fileNo"
                                    tabindex="33" />
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group">
                                <label class="small">RH</label>
                                <sanabel-selectize appcode="290" [tabindex]="34" formControlName="rhValue"
                                    [simpleView]="true">
                                </sanabel-selectize>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-3">
                            <sanabel-selectize appcode="24" [tabindex]="35" formControlName="bloodGroup">
                            </sanabel-selectize>
                        </div>
                        <div class="col-3">
                            <div class="form-group">
                                <label>{{'VIPLEVEL' | translate}}</label>
                                <input type="number" class="form-control form-control-sm"
                                    [(ngModel)]="editPatient.vipLevel" formControlName="vipLevel" tabindex="37" />
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group">
                                <label>{{'NICKNAME' | translate}}</label>
                                <input class="form-control form-control-sm" type="text" formControlName="nickName"
                                    tabindex="36" />
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group">
                                <label>{{'VIPLEVEL' | translate}}</label>
                                <sanabel-selectize appcode="977" formControlName="visitDays">
                                </sanabel-selectize>
                            </div>
                        </div>
                    </div>

                    <!--*******************************************************************************************************************-->
                    <div class="row">
                        <div class="col-6">
                            <div>
                                <strong>{{'HEELSAMPLE' | translate}}</strong> :
                                <input type="radio" id="elqods" name="heelSampleFlag" formControlName="heelSampleFlag"
                                    [value]="1" />
                                <label class="form-check-label" for="elqods">
                                    {{translate.currentLang == 'ar' ? 'القدس' :'El Qods'}}
                                </label>
                                <input type="radio" id="fromOutSide" formControlName="heelSampleFlag"
                                    name="heelSampleFlag" [value]="2" />
                                <label class="form-check-label" for="fromOutSide">
                                    {{'FROMOUTSIDE' | translate}}
                                </label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div>
                                <strong>{{translate.currentLang == 'ar' ? 'عينة التهاب كبدي وبائي' :'Hepatitis epidemic
                                    sample'}}</strong> :
                                <input type="radio" id="done" name="hepatitisEpidemicSampleFlag"
                                    formControlName="hepatitisEpidemicSampleFlag" [value]="1" />
                                <label class="form-check-label" for="done">
                                    {{'DONE' | translate}}
                                </label>
                                <input type="radio" id="notDone" formControlName="hepatitisEpidemicSampleFlag"
                                    name="hepatitisEpidemicSampleFlag" [value]="2" />
                                <label class="form-check-label" for="notDone">
                                    {{'NOTDONE' | translate}}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 form-check">
                            <div>
                                <input type="checkbox" id="stopFlag" #stopFlagCheckBox
                                    (click)="getStopFlag(stopFlagCheckBox.checked)" formControlName="stopFlag"
                                    tabindex="37" />
                                <label class="form-check-label" for="stopFlag">
                                    {{'STOPFLAG' | translate}}
                                </label>
                            </div>

                            <div>
                                <input type="checkbox" id="vipFlag" formControlName="vipFlag" tabindex="39" />
                                <label class="form-check-label" for="vipFlag">
                                    {{'VIPFLAG' | translate}}
                                </label>
                            </div>

                            <div>
                                <input type="checkbox" id="mortaliyFlag" formControlName="mortaliyFlag" tabindex="40" />
                                <label class="form-check-label" for="mortaliyFlag">
                                    {{'mortaliyFlag' | translate}}
                                </label>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="form-group">
                                <label class="small">{{'DateOfBarth' | translate}}</label>
                                <div class="input-group input-group-sm">
                                    <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                                        formControlName="mortalityDateNgb" tabindex="41" ngbDatepicker
                                        #mortalityDate="ngbDatepicker">
                                    <div class="input-group-addon" (click)="mortalityDate.toggle()">
                                        <i class="fa fa-calculator"></i>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <h6 class="card-header" (click)="toggleSpecailNeeds()" style="cursor: pointer;">
                    {{'SPECIALNEEDS' | translate}}</h6>
                <div class="card-block" *ngIf="specailNeeds">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-4">
                            <sanabel-selectize formControlName="specialNeedType" appcode="375">
                            </sanabel-selectize>
                        </div>
                        <div class="col-12">
                            <label>{{'DESCRIPTION' |translate}} </label>
                            <input formControlName="specialNeedDesc" class="form-control" type="text">
                        </div>
                    </div>
                </div>

                <h6 class="card-header" (click)="toggleChronic()" style="cursor: pointer;">
                    {{'CHRONICILLNESS' | translate}}</h6>
                <div class="card-block" *ngIf="chronic">
                    <emr-chronic #emrChronicComponent [addNewChronic]="true"></emr-chronic>
                </div>

            </div>


        </div>
    </div>
    <div>
        <div class="row">
            <div class="col" [hidden]="addRelativeMode">
                <btns-ctrl #btnCtrl1 [paramsArr]="controlsParams" (clicked)="onClicked($event)" [tabindex]="41">
                </btns-ctrl>

            </div>
            <div class="col" *ngIf="addRelativeMode">
                <button class="btn btn-success" [ngClass]="{'disabledDiv':patientForm.invalid}" (click)="addrelative()"
                    tabindex="42">
                    {{'ADDFORFAMILY' | translate}}
                </button>

                <button class="btn btn-default" (click)="canceladdrelative()" tabindex="42">
                    {{'CANCELELATION' | translate}}
                </button>
            </div>
        </div>
    </div>

    <ng-template #content let-c="close" let-d="dismiss" *ngIf="editPatient.code != undefined">
        <div class="modal-header">
            <h4 class="modal-title">{{'patCancel' | translate}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <router-outlet></router-outlet>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="c('Close click')">{{'patCancel' |
                translate}}</button>
        </div>
    </ng-template>

</form>

<div [hidden]="!toggle">
    <ng-template #content let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title">الاسماء المتشابه</h4>
            <button type="button" class="close" aria-label="Close" ( click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>

            <!--<i *ngFor="let x of MVObj;let i = index">-->


        </div>
        <div class="modal-body">
            <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="phoneNumbers" [rows]="10"
                [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]">
                <p-column field="code" header="{{ 'CODE' | translate }}" [sortable]="true"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'fullnameAr':'fullnameEn'}}"
                    header="{{ 'Name' | translate }}" [sortable]="true"></p-column>
                <p-column field="mobile" header="{{ 'MOBILENUMBER' | translate }}" [sortable]="true"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'fullAddressAr':'fullAddressAr'}}"
                    header="{{ 'ADDRESS' | translate }}" [sortable]="true"></p-column>
                <p-column field="gender" header="{{ 'GENDER' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <img style="width:25px; height:25px;"
                            src="../../../assets/images/Gender{{row['gender']}}.png" />
                    </ng-template>
                </p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'flagAr':'flagEn'}}"
                    header="{{ 'TYPE' | translate }}" [sortable]="true"></p-column>
                <p-column>
                    <ng-template pTemplate="options" let-row="rowData">
                        <icon-action (clicked)="similarPatRowIconClick(row);c('Close click')" [appCodes]="[404]">
                        </icon-action>
                    </ng-template>
                </p-column>

            </p-dataTable>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
        </div>
    </ng-template>
</div>

<style>
    .testClass {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: -20px;
        margin-bottom: -15px;
        padding-right: 18px;
    }
</style>